export default __webpack_public_path__ + "static/media/ProximaNova-Black.829f67ae.otf";